module.exports = __webpack_public_path__ + "assets/bgOzonMobile.98a1dd7e5ebd1d1e3c3219a485939693.jpg";